module.exports = __webpack_public_path__ + "static/media/icons-ic-decision-call-status.f6a09f48.svg";